module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('popup', {
    staticStyle: {
      "height": "96%",
      "border-radius": "4px 4px 0 0",
      "position": "fixed",
      "max-height": "700px",
      "top": "40px"
    },
    attrs: {
      "position": "bottom",
      "show-mask": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "nav-header",
    staticStyle: {
      "position": "fixed",
      "top": "40px",
      "left": "0",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticClass: "nav-header-left"
  }, [_c('a', {
    staticClass: "nav-header-back text-default",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('span', {
    staticClass: "city-down"
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "nav-header-title"
  }, [_vm._v("热门城市")])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-header",
    staticStyle: {
      "padding-top": "44px",
      "overflow-y": "auto",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "wrapper bg-light",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n        当前定位城市: " + _vm._s(_vm.currentLocation.city) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "panel",
    staticStyle: {
      "min-height": "700px",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "panel-body text-lg"
  }, _vm._l((_vm.list), function(group) {
    return _c('div', {
      staticClass: "list-group list-group-underline list-group-lg"
    }, [_c('div', {
      staticClass: "text-xlg",
      staticStyle: {
        "padding-top": "20px",
        "font-family": "PingFangSC-Semibold"
      }
    }, [_vm._v(_vm._s(group.letter))]), _vm._v(" "), _vm._l((group.citylist), function(city) {
      return (city.city) ? _c('div', {
        staticClass: "list-group-item city-cityname",
        staticStyle: {
          "padding": "10px 0"
        },
        on: {
          "click": function($event) {
            return _vm.setCurrentCity(city)
          }
        }
      }, [_vm._v("\n              " + _vm._s(city.city) + "\n            ")]) : _vm._e()
    })], 2)
  }), 0)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ab13698"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/city-picker/index.vue
// module id = 284
// module chunks = 107